// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"info-card_itemContainer__zZ3Rl","itemLabel":"info-card_itemLabel__C_rK1","itemContent":"info-card_itemContent__Mi7Rb"};